import { Routes, Route, Navigate, useNavigate } from "react-router-dom";
import useGetRoutes from "./app-routes";
import { SideNavOuterToolbar as SideNavBarLayout } from "./layouts";
import StartupError from "./pages/error/StartupError";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";
import { useEffect } from "react";
import { useSelector } from "react-redux";

export default function Content() {
  const routes = useGetRoutes();
  const errorFetchingActions = useSelector(
    (state) => state.errorFetchingActions
  );
  const navigate = useNavigate();

  useEffect(() => {
    if (errorFetchingActions) {
      navigate("error");
    }
  }, [errorFetchingActions, navigate]);

  return (
    <ErrorBoundary>
      <SideNavBarLayout title={""}>
        <Routes>
          {errorFetchingActions ? (
            <Route path={"error"} element={<StartupError />} />
          ) : (
            <>
              {routes.map(({ path, element }) => (
                <Route key={path} path={path} element={element} />
              ))}

              <Route path="*" element={<Navigate to="/" />} />
            </>
          )}
        </Routes>
      </SideNavBarLayout>
    </ErrorBoundary>
  );
}
